import { Image } from "@storybook"; // Importing the Image component from Storybook

import { Label } from "components/label"; // Importing the Label component
import { Description } from "components/description"; // Importing the Description component

import "./verified-screen.scss"; // Importing the SCSS file for styling

interface IVerifiedScreen {
  image?: string; // Optional image URL or file name to display
  sublabel?: string; // Optional sublabel text to display below the image
  label?: string; // Optional main label text to display
}

/**
 * VerifiedScreen component displays a verification screen with an image, sublabel, and label.
 *
 * @param {IVerifiedScreen} props - The properties object for the VerifiedScreen component.
 * @param {string} [props.image] - The image URL or file name to display.
 * @param {string} [props.sublabel] - The sublabel text to display below the image.
 * @param {string} [props.label] - The main label text to display.
 *
 * @returns {JSX.Element} The rendered VerifiedScreen component.
 */
export const VerifiedScreen = ({ image, sublabel, label }: IVerifiedScreen) => {
  return (
    <div className="verified-screen-wrapper">
      <div className="content-center">
        <div>
          <div className="flex-column-center gap-8">
            {/* Display the image */}
            <Image fileName={image} />
            <div className="flex-column-center gap-8">
              {/* Display the sublabel */}
              <Description content={sublabel} className="text-center" />
              {/* Display the main label */}
              <Label className="text-center" content={label} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
